module.exports = __webpack_public_path__ + "img/26-insee1994-min.a2982053.jpg";